import { render, staticRenderFns } from "./CalendarOverviewEvent.vue?vue&type=template&id=5a57cd27&"
import script from "./CalendarOverviewEvent.vue?vue&type=script&lang=js&"
export * from "./CalendarOverviewEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports